module.exports = __webpack_public_path__ + "img/background_general_grey.b283b3a6.jpg";